import { defineHub } from "../classes/HubDefinition";
export default defineHub({
    // #region Run
    name: 'notification',
    // #endregion
    // #region Core
    async execute(command, args) {
        if (command.address === 'showquestion') {
            return await this.showQuestion(command);
        }
        else if (command.address === 'showtoast') {
            return await this.showToast(command);
        }
        else {
            appHost.notification.showToast("Invalid command '" + command.address + "' in handler '" + this.name + "'.", "warning");
            return this.Cancel();
        }
    },
    // #endregion
    // #region Methods
    methods: {
        async showQuestion(command) {
            let tResult = await appHost.notification.showQuestionAsync({
                title: command.data.title,
                message: command.data.message,
            });
            return this.Window(tResult);
        },
        async showToast(command) {
            appHost.notification.showToast(command.data.message, command.data.type);
            return this.Ok();
        },
    }
    // #endregion
});
